class FarloUiLightbox {
	constructor(element) {
		this.element = element;
		this.lightbox = document.querySelector('.farlo-ui-lightbox');
		this.lightboxContent = this.lightbox.querySelector('.farlo-ui-lightbox__content');
		this.lightboxContentInner = this.lightbox.querySelector('.farlo-ui-lightbox__content-inner');
		this.closeButton = this.lightbox.querySelector('.farlo-ui-lightbox__close');
		this.backdrop = this.lightbox.querySelector('.farlo-ui-lightbox__backdrop');
		const youTubeRegex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
        this.lightboxInner = this.lightbox.querySelector('.farlo-ui-lightbox__inner');
        this.lightboxInner.addEventListener('click', this.handleInnerClick.bind(this));
		this.scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

		this.element.addEventListener('click', this.openLightbox.bind(this));
		this.closeButton.addEventListener('click', this.closeLightbox.bind(this));
		this.backdrop.addEventListener('click', this.closeLightbox.bind(this));
		this.lightbox.addEventListener('keydown', this.handleKeydown.bind(this));
		this.element.setAttribute('aria-haspopup', 'dialog');
		this.lightbox.setAttribute('role', 'dialog');
		this.lightbox.setAttribute('aria-modal', 'true');
		this.lightbox.setAttribute('aria-hidden', 'true');
		this.closeButton.setAttribute('aria-label', 'Close Lightbox');
		
	}

	helperIsImageType(src) {
		return /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(src);
	}

	helperValueNullOrUndefined(checkedElement) {
		return checkedElement && typeof checkedElement !== 'undefined' && typeof checkedElement.value !== 'undefined' && checkedElement.value !== '';
	}



	openLightbox() {
		// Find the hidden input field with the class farlo-ui-lightbox__html
		const inputField = this.element.querySelector('.farlo-ui-lightbox__html');


		if (inputField && inputField.value) {
			const content = inputField.value;
			this.lightboxContentInner.innerHTML = content;
			this.lightbox.classList.add('farlo-ui-lightbox--active');
			this.lightbox.removeAttribute('aria-hidden');
			this.lightbox.focus();
		} else {
			console.error('Hidden input field with class farlo-ui-lightbox__html not found or empty.');
		}

		document.body.style.paddingRight = `${this.scrollbarWidth}px`;
        document.body.style.overflow = 'hidden';
	}

	closeLightbox() {
		    // Store the current scroll position
    const scrollPosition = window.scrollY || window.pageYOffset;

    // Your existing code...

    setTimeout(() => {
        // Restore the scroll position after a short delay
        window.scrollTo(0, scrollPosition);
    }, 0);
		this.lightbox.classList.remove('farlo-ui-lightbox--active');

		

		setTimeout(() => {
			if (!this.element.nextElementSibling) {
				this.lightboxContentInner.innerHTML = '';
			}
			this.lightbox.setAttribute('aria-hidden', 'true');
			this.element.focus();
		}, 300);
		document.body.style.paddingRight = '';
        document.body.style.overflow = '';
	}

	handleInnerClick(event) {
        // Check if the click target is outside the content inner div
        if (!event.target.closest('.farlo-ui-lightbox__content-inner')) {
            this.closeLightbox();
        }
    }

	handleKeydown(event) {
		if (event.key === 'Escape') {
			this.closeLightbox();
		}
	}
}

export default FarloUiLightbox;
